export const CREATE_COLLECTION_REQUESTED = 'CREATE_COLLECTION_REQUESTED';
export const CREATE_COLLECTION_SUCCEEDED = 'CREATE_COLLECTION_SUCCEEDED';
export const CREATE_NEW_USER_COLLECTION_REQUESTED = 'CREATE_NEW_USER_COLLECTION_REQUESTED';
export const CREATE_NEW_USER_COLLECTION_SUCCEEDED = 'CREATE_NEW_USER_COLLECTION_SUCCEEDEDs';
